import React from "react";
import * as Icon from "react-feather";

import WComponent from "../../../common/WComponent";
import ToolsModal from "../kit/ToolsModal";
import ToolsSelect from "../kit/ToolsSelect";

class AddClassificationModal extends WComponent {
	constructor(props) {
		super(props);

		this.state = {
			name: "",
			canonicalCode: "",
			tax: "",
			saving: false,
		};
	}

	canAdd = () => {
		const hasName = this.state.name.trim() !== "";
		const hasStatementLine = this.state.canonicalCode !== "";
		const canAdd = hasName && hasStatementLine && !this.state.saving;
		return canAdd;
	};

	onAddClicked = async () => {
		const { onAdd, onClose } = this.props;
		if (!this.canAdd()) return;

		await this.update({ saving: true });
		const added = await onAdd({ name: this.state.name.trim(), canonicalCode: this.state.canonicalCode, tax: this.state.tax });
		await this.update({ saving: false });

		if (added) onClose();
	};

	renderFooter = () => {
		const { onClose } = this.props;

		return (
			<>
				<span />
				<span className="tk-modal-actions">
					<button type="button" className="tk-button tk-button--secondary" onClick={onClose}>Cancel</button>
					<button type="button" className="tk-button tk-button--primary" onClick={this.onAddClicked} disabled={!this.canAdd()}>
						<Icon.Plus size={16} />
						{this.state.saving ? "Adding…" : "Add account"}
					</button>
				</span>
			</>
		);
	};

	render() {
		const { taxOptions, canonicalOptions, onClose } = this.props;
		const { name, canonicalCode, tax } = this.state;

		const statementLineChoices = (canonicalOptions || []).map(option => ({ value: option.canonical_code, label: option.display_name }));
		const taxChoices = [{ value: "", label: "— No default —" }, ...taxOptions.map(taxOption => ({ value: taxOption, label: taxOption }))];

		return (
			<ToolsModal open={true} onClose={onClose} title="Add chart account" width={440} footer={this.renderFooter()}>
				<div className="tk-form-field">
					<div className="tk-form-label">Account name <span className="tk-form-required">*</span></div>
					<input
						className="tk-input"
						value={name}
						onChange={e => this.update({ name: e.target.value })}
						placeholder="e.g. Office Supplies"
						autoFocus
					/>
				</div>
				<div className="tk-form-field">
					<div className="tk-form-label">Reports on <span className="tk-form-required">*</span></div>
					<ToolsSelect
						value={canonicalCode}
						options={statementLineChoices}
						onChange={chosenCode => this.update({ canonicalCode: chosenCode })}
						placeholder="Select the financial statement line…"
						searchable
						searchPlaceholder="Search statement lines…"
					/>
					<div className="tk-form-help">The line this account rolls up into on the financial statements.</div>
				</div>
				<div className="tk-form-field">
					<div className="tk-form-label">Default tax</div>
					<ToolsSelect
						value={tax}
						options={taxChoices}
						onChange={selectedTax => this.update({ tax: selectedTax })}
						placeholder="— No default —"
					/>
					{taxOptions.length === 0 && <div className="tk-form-help">Select a province in Settings to see tax options.</div>}
				</div>
			</ToolsModal>
		);
	}
}

export default AddClassificationModal;
